export const HAVE_UNREAD_MESSAGES = 'HAVE_UNREAD_MESSAGES';
export const UPDATE_UNREAD_MESSAGES = 'UPDATE_UNREAD_MESSAGES';
export const ALLOWED_HELP_DESK = 'ALLOWED_HELP_DESK';
export const SEARCH_VIN = 'SEARCH_VIN';
export const SEARCH_VIN_AUDIT = 'SEARCH_VIN_AUDIT';
export const PAGINATION_SETTINGS = 'PAGINATION_SETTINGS';
export const PAGINATION_SETTINGS_AUDIT = 'PAGINATION_SETTINGS_AUDIT';

